var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassEmptyState",
    {
      attrs: {
        illustrationPath: "/ressources/logged/img/illustrations/no-results.svg",
        title: _vm.$t.__("email.listings.EmailListingTableEmpty.no_result")
      }
    },
    [
      _vm.hasActiveFilters
        ? _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.reset") },
            on: { click: _vm.handleResetFilters }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }